module.exports = __webpack_public_path__ + "media/images/story/typo/welcome-68444cfdc4682dd33ca34bc070041ed3.svg";